import React, { ReactElement } from 'react';

function CanLoad(props: { content: any }): ReactElement {
    const { content: Content } = props;
    return <Content />;
}

export default CanLoad;
